import React, {Fragment, useMemo, useState} from "react";
import {Button, Card, Col, Input, Modal, Radio, Row} from "antd";
import {
    GUTTER_MD,
    GUTTER_SM,
    MARGIN_MD,
    MODAL_WIDTH_LG,
    MODAL_WIDTH_XL
} from "../../../../../styles/constants";
import {translate} from 'react-i18next';
import {connect} from "react-redux";
import {compose} from "redux";
import {getStrAccordingToFilterMode, QUERY_FORM_FILTER_MODE_PLAIN, QUERY_FORM_FILTER_MODE_TREE} from "./filterUtils";
import {
    convertFilterStrWithSimpleFilterForTimePeriod,
} from "../../../../../components/tree-filter/utils";
import EnhancedModal from "../../../../../components/enhanced-modal";
import FilterForm from "../../../../../components/filter-form";
import TreeFilter from "../../../../../components/tree-filter";
import {
    addDatasetBuilderWizardQueryFilterFormBlock,
    addDatasetBuilderWizardQueryFilterFormCondition,
    changeDatasetBuilderWizardFilterForm,
    changeDatasetBuilderWizardQueryFilterMode,
    changeDatasetBuilderWizardQueryTreeFilter,
    changeDatasetBuilderWizardQueryTreeFilterColumnMode,
    changeDatasetBuilderWizardQueryTreeFilterColumnValues,
    deleteDatasetBuilderWizardQueryFilterFormBlock,
    deleteDatasetBuilderWizardQueryFilterFormCondition,
    readDatasetBuilderWizardQueryFilterFormColumnValues,
    readDatasetBuilderWizardQueryFilterFormFilterColumnsValues,
    resetAllDatasetBuilderWizardQueryFilter,
    resetDatasetBuilderWizardQueryFilter,
    resetDatasetBuilderWizardQueryFilterFormColumnValues,
    submitDatasetBuilderWizardQueryFilterModal
} from "../actions";
import UnionDraggableItems from "./UnionDraggableItems";
import {readDatasetBuilderWizardQueryPreviewRows} from "../../actions";
import ZoomableHighlightedTextarea from "../../../../../components/zoomable-highlighted-textarea";
import ObjectPreview from "./ObjectPreview";
import {buildIndividualSQL, QUERY_HEIGHT, wrapColumnWithDBSpecificParenthesis} from "./utils";
import {getFilterObjFromViewerObj} from "../../../../../utils/filter";
import FixedColModal from "../FixedColModal";

const mapStateToProps = state => {
    const {currentlySelectedTable} = state.scenes.mappingHandler.datasetBuilder.unionModalProps;
    return {
        appLanguage: state.app.language,
        dataLanguages: state.config.dataManagement.dataLanguages,
        connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
        filter: state.scenes.mappingHandler.datasetBuilder.unionModalProps.filter,
        filterTemp: state.scenes.mappingHandler.datasetBuilder.unionModalProps.filterTemp,
        treeFilter: state.scenes.mappingHandler.datasetBuilder.unionModalProps.treeFilter,
        treeFilterTemp: state.scenes.mappingHandler.datasetBuilder.unionModalProps.treeFilterTemp,
        filterMode: state.scenes.mappingHandler.datasetBuilder.unionModalProps.filterMode,
        rows: state.scenes.mappingHandler.datasetBuilder.index.rows,
        tableViewId: currentlySelectedTable && currentlySelectedTable.tableViewId ? currentlySelectedTable.tableViewId : null,
        aliasCols: state.scenes.mappingHandler.datasetBuilder.unionModalProps.aliasCols,
        tableViewColumns: state.scenes.mappingHandler.datasetBuilder.unionModalProps.tableViewColumns,
        connections: state.scenes.mappingHandler.datasetBuilder.index.connections,
    }
};

const mapDispatchToProps = dispatch => ({
    onFilterModalSubmit: (treeFilter, filterStr) => dispatch(submitDatasetBuilderWizardQueryFilterModal(treeFilter, filterStr)),
    onFilterModeChange: filterMode => dispatch(changeDatasetBuilderWizardQueryFilterMode(filterMode)),
    onFilterReset: () => dispatch(resetDatasetBuilderWizardQueryFilter()),
    onFilterResetAll: () => dispatch(resetAllDatasetBuilderWizardQueryFilter()),
    onFilterChange: fields => dispatch(changeDatasetBuilderWizardFilterForm(fields)),
    onBlockAdd: () => dispatch(addDatasetBuilderWizardQueryFilterFormBlock()),
    onBlockDelete: blockIndex => dispatch(deleteDatasetBuilderWizardQueryFilterFormBlock(blockIndex)),
    onConditionAdd: blockIndex => dispatch(addDatasetBuilderWizardQueryFilterFormCondition(blockIndex)),
    onConditionDelete: (blockIndex, conditionIndex) => dispatch(deleteDatasetBuilderWizardQueryFilterFormCondition(blockIndex, conditionIndex)),
    fetchColumnFilteredValues: (
        colNames,
        connId,
        query,
        limit = -1,
        page = 0,
    ) => dispatch(readDatasetBuilderWizardQueryFilterFormFilterColumnsValues(colNames, connId, limit, page, query)),
    onTreeFilterChange: treeFilter => dispatch(changeDatasetBuilderWizardQueryTreeFilter(treeFilter)),
    onColumnModeChange: (colName, mode) => dispatch(changeDatasetBuilderWizardQueryTreeFilterColumnMode(colName, mode)),
    onColumnValuesChange: (colName, values) => dispatch(changeDatasetBuilderWizardQueryTreeFilterColumnValues(colName, values)),
    fetchRows: ({connId, limit, page, query, searchText, filters, sortCol, sortByDesc, rows}) =>
        dispatch(readDatasetBuilderWizardQueryPreviewRows(connId, limit, page, query, searchText, getFilterObjFromViewerObj(rows && rows.columns, searchText, filters), sortCol, sortByDesc)),
    fetchColumnValues: ({columnName, connId, limit, page, searchText, query}) =>
        dispatch(readDatasetBuilderWizardQueryFilterFormColumnValues(columnName, connId, limit, page, searchText, query, getFilterObjFromViewerObj([columnName], searchText))),
    resetColumnValues: columnName =>
        dispatch(resetDatasetBuilderWizardQueryFilterFormColumnValues(columnName)),
});

const UnionQueryFilters = ({
                               connId,
                               connections,
                               t,
                               onFilterModalSubmit,
                               filterMode,
                               filter,
                               filterTemp,
                               treeFilter,
                               treeFilterTemp,
                               disabled,
                               onFilterModeChange,
                               onFilterReset,
                               onFilterResetAll,
                               onFilterChange,
                               onBlockAdd,
                               onBlockDelete,
                               onConditionAdd,
                               onConditionDelete,
                               fetchColumnFilteredValues,
                               onTreeFilterChange,
                               onColumnModeChange,
                               onColumnValuesChange,
                               rows,
                               fetchRows,
                               fetchColumnValues,
                               resetColumnValues,
                               sdmxFilters,
                               aliasCols,
                               tableViewColumns,
                               tableViewId
                           }) => {
    const [isFilterQueryModalVisible, setIsFilterQueryModalVisible] = useState(false);
    const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
    const [isRowsModalVisible, setIsRowsModalVisible] = useState(false);
    const [showFixedValColModal, setShowFixedValColModal] = useState(false);
    const selectedConnection = useMemo(() => (connections || []).find(item => item.entityId === connId), [connections, connId]);

    const columns = useMemo(() => {
        let resultColumns;
        if (tableViewColumns) {
            resultColumns = tableViewColumns.dimensions.map(col => ({
                ...col,
                fetchValues: viewerObj =>
                    fetchColumnValues({
                        columnName: col.Code,
                        viewerObj,
                        connId,
                        limit: viewerObj.pageSize,
                        page: viewerObj.pageNum - 1,
                        searchText: viewerObj.searchText,
                        query: `SELECT DISTINCT ${wrapColumnWithDBSpecificParenthesis(col.Code, selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null)}
                                FROM ${tableViewId}`
                    }),
                resetValues: () => resetColumnValues(col.Code),
                hasCodelist: false,
            }))
        }

        return resultColumns || [];
    }, [aliasCols, tableViewColumns]);

    const filterStr = useMemo(() =>
        getStrAccordingToFilterMode(filterMode, filter, treeFilter, columns), [filterMode, filter, treeFilter, columns]);

    const filterTempStr = useMemo(() =>
        getStrAccordingToFilterMode(filterMode, filterTemp, treeFilterTemp, columns), [filterMode, filterTemp, treeFilterTemp, columns]);

    if (!columns) {
        return null;
    }

    return (
        <Fragment>
            <Row type="flex" style={{flexDirection: "column", height: "100%"}}>
                <Col>
                    <Card style={{ width: "100%", marginBottom: GUTTER_MD}} bodyStyle={{
                        overflow: "auto",
                        // 264px valid until the modal is kept fullscreen
                        height: `calc(100vh - 264px - ${QUERY_HEIGHT}px)`,
                    }}>
                        <UnionDraggableItems/>
                    </Card>
                </Col>
                <Col>
                    <Row type="flex" gutter={GUTTER_SM} justify="space-between">
                        <Col>
                            <Button type="primary" onClick={() => setShowFixedValColModal(true)}
                                    style={{marginRight: MARGIN_MD}}>
                                {t('scenes.mappingHandler.DatasetBuilder.wizard.step.query.fixedValueColumn.title')}
                            </Button>
                            <Button type="primary" onClick={() => setIsFilterModalVisible(true)}
                                    disabled={(!tableViewColumns && !!tableViewId) || !aliasCols || aliasCols.length === 0}
                                    style={{marginRight: MARGIN_MD}}>
                                {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.editFilter.title')}
                            </Button>
                            <Button onClick={() => onFilterResetAll()}
                                    disabled={(!tableViewColumns && !!tableViewId) || !aliasCols || aliasCols.length === 0 || (!filterStr && !filterTempStr)}>
                                {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.clearFilter.title')}
                            </Button>
                        </Col>
                        <Col>
                            <Button onClick={() => {
                                setIsRowsModalVisible(true);
                            }} disabled={(!tableViewColumns && !!tableViewId) || !aliasCols || aliasCols.length === 0}
                                    icon="eye">
                                {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.preview.title')}
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <div style={{fontFamily: 'monospace', marginTop: MARGIN_MD, height: QUERY_HEIGHT}}>
                        <ZoomableHighlightedTextarea
                            disabled
                            value={buildIndividualSQL(aliasCols, tableViewId, convertFilterStrWithSimpleFilterForTimePeriod(filterStr), selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null)}
                            modalProps={{bodyStyle: {height: "75vh"}, width: MODAL_WIDTH_XL}}
                        />
                    </div>
                </Col>
            </Row>
            <EnhancedModal
                visible={isFilterModalVisible}
                onCancel={() => setIsFilterModalVisible(false)}
                footer={
                    <div>
                        <Button
                            onClick={() => setIsFilterModalVisible(false)}>{t('commons.buttons.cancel.title')}</Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                onFilterModalSubmit(filterMode === QUERY_FORM_FILTER_MODE_PLAIN
                                        ? filterTemp
                                        : treeFilterTemp,
                                    filterTempStr
                                );
                                setIsFilterModalVisible(false);
                            }}
                        >
                            {t('commons.buttons.confirm.title')}
                        </Button>
                    </div>
                }
                width={MODAL_WIDTH_LG}
                title={t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterModal.title')}
            >
                <EnhancedModal
                    visible={isFilterQueryModalVisible}
                    onCancel={() => setIsFilterQueryModalVisible(false)}
                    footer={<Button
                        onClick={() => setIsFilterQueryModalVisible(false)}>{t('commons.buttons.close.title')}</Button>}
                    width={MODAL_WIDTH_LG}
                    title={t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterQueryModal.title')}
                >
                    <div style={{fontFamily: 'monospace'}}>
                        <Input.TextArea
                            disabled
                            value={convertFilterStrWithSimpleFilterForTimePeriod(filterTempStr)}
                            style={{
                                overflow: 'auto',
                                resize: 'none',
                                height: 560
                            }}
                        />
                    </div>
                </EnhancedModal>
                <Row type="flex" justify="space-between" style={{marginBottom: MARGIN_MD}}>
                    <Col>
                        {!sdmxFilters && (
                            <Radio.Group
                                disabled={disabled}
                                value={filterMode}
                                onChange={({target}) => {
                                    if (
                                        (target.value === QUERY_FORM_FILTER_MODE_PLAIN && Object.keys(treeFilterTemp).length > 0) ||
                                        (target.value === QUERY_FORM_FILTER_MODE_TREE && filterTempStr.length > 0)
                                    ) {
                                        Modal.confirm({
                                            title: t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.title'),
                                            content: t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.content'),
                                            onOk() {
                                                onFilterModeChange(target.value);
                                            },
                                            cancelText: t('commons.buttons.cancel.title')
                                        })
                                    } else {
                                        onFilterModeChange(target.value)
                                    }
                                }}
                            >
                                <Radio.Button value={QUERY_FORM_FILTER_MODE_PLAIN}>
                                    {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.plain.title')}
                                </Radio.Button>
                                <Radio.Button value={QUERY_FORM_FILTER_MODE_TREE}>
                                    {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.tree.title')}
                                </Radio.Button>
                            </Radio.Group>
                        )}
                    </Col>
                    <Col>
                        <Row type="flex" gutter={GUTTER_SM}>
                            <Col>
                                <Button icon="code" onClick={() => setIsFilterQueryModalVisible(true)}>
                                    {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.showQuery.title')}
                                </Button>
                            </Col>
                            <Col>
                                <Button icon="delete" onClick={onFilterReset} disabled={disabled}>
                                    {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.resetFilter.title')}
                                </Button>
                            </Col>
                            <Col>
                                <Button onClick={() => setIsRowsModalVisible(true)}
                                        disabled={!tableViewColumns}
                                        icon="eye">
                                    {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.preview.title')}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {
                    filterMode === QUERY_FORM_FILTER_MODE_PLAIN && (
                        <Card bodyStyle={{height: 396, overflow: "auto"}}>
                            <FilterForm
                                filter={filterTemp}
                                columns={columns}
                                onChange={onFilterChange}
                                onBlockAdd={onBlockAdd}
                                onBlockDelete={onBlockDelete}
                                onBlockConditionAdd={onConditionAdd}
                                onBlockConditionDelete={onConditionDelete}
                                disabled={disabled}
                            />
                        </Card>
                    )}
                {filterMode === QUERY_FORM_FILTER_MODE_TREE && (
                    <div className="query__tree-filter">
                        <TreeFilter
                            disabled={disabled}
                            columns={columns}
                            fetchColumnFilteredValues={({colNames, filterStr}) =>
                                fetchColumnFilteredValues(colNames, connId, `SELECT DISTINCT ${colNames.map(name =>
                                        wrapColumnWithDBSpecificParenthesis(name, selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null)).join(", ")}
                                                                             FROM ${tableViewId} ${filterStr ? `WHERE ${filterStr}` : ""}`)}
                            onChange={onTreeFilterChange}
                            treeFilter={treeFilterTemp}
                            onColumnModeChange={onColumnModeChange}
                            onColumnValuesChange={onColumnValuesChange}
                            hideInclusionRadio={sdmxFilters}
                            isSdmx={sdmxFilters}
                            isDdbDataflow={true}
                            skipCheckNextColumn={false}
                        />
                    </div>
                )}
            </EnhancedModal>
            <ObjectPreview
                connId={connId}
                query={buildIndividualSQL(aliasCols, tableViewId, isFilterModalVisible ? filterTempStr : filterStr, selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null)}
                rows={rows}
                isRowsModalVisible={isRowsModalVisible}
                onRowsModalHide={() => setIsRowsModalVisible(false)}
                fetchRows={fetchRows}
            />
            <FixedColModal isModalVisible={showFixedValColModal} onModalHide={() => setShowFixedValColModal(false)}/>
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(UnionQueryFilters);
